"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function VerdictBox() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#064e3b] text-white py-12 px-8 my-12 rounded-xl">
      <h2 className="text-3xl font-bold mb-4">{t("blog.shutters.verdictTitle")}</h2>
      <p className="text-white/90 leading-relaxed max-w-3xl">
        {t("blog.shutters.verdictText")}
      </p>
    </section>
  );
}